// Copyright (c) 2020 Deere & Company

import {getRgaDetails, getRgaFiles} from './rga-details';
import {
    onMassUpdateRequest,
    setSelectedRga
} from './rga-selected-mass-update';
import {
    openMassUpdateModal,
    openMassUploadModal
} from '../../search/action-creators/search';
import {
    resetRgaResultsNavigation,
    setRgaResultsNavigation
} from './results-navigation';
import {
    resetRgaSearchModelObject,
    resetRgaSearchObjectDateValues,
    resetRgaSearchObjectListValues,
    resetRgaSearchObjectValues
} from '../../search/action-creators/rga-search';
import {
    setRouteToReturnPartAttachmentTab,
    updateFilterBy,
    updateSortBy,
    updateSortDirection
} from './search-filters';
import {
    getRgaCollections
} from './rga-list';
import {
    setRgaResultFlag
} from './rga-result-list-flag';

export default {
    getRgaCollections,
    getRgaDetails,
    getRgaFiles,
    onMassUpdateRequest,
    openMassUpdateModal,
    openMassUploadModal,
    resetRgaResultsNavigation,
    resetRgaSearchModelObject,
    resetRgaSearchObjectDateValues,
    resetRgaSearchObjectListValues,
    resetRgaSearchObjectValues,
    setRgaResultFlag,
    setRgaResultsNavigation,
    setRouteToReturnPartAttachmentTab,
    setSelectedRga,
    updateFilterBy,
    updateSortBy,
    updateSortDirection
};



// WEBPACK FOOTER //
// ./src/rga/rga-search-results/action-creators/index.js